import { useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import { clearParams } from '~/shared';
import {
  SponsoredProductsReportsCampaignDto,
  SponsoredProductsReportsCampaignModelView,
} from '~/types';

export const GET_SPONSORED_PRODUCTS_REPORTS_CAMPAIGN_QUERY_KEY =
  'GET_SPONSORED_PRODUCTS_REPORTS_CAMPAIGN_QUERY';

function getSponsoredProductsReportsCampaign(
  params: SponsoredProductsReportsCampaignDto
) {
  const clearedParams = clearParams(
    params
  ) as SponsoredProductsReportsCampaignDto;

  return serviceApi.get<SponsoredProductsReportsCampaignModelView>(
    `/ReportProdutoPatrocinado/Produtos`,
    {
      params: clearedParams,
    }
  );
}

export function useGetSponsoredProductsReportsCampaign(
  params: SponsoredProductsReportsCampaignDto
) {
  return useQuery({
    queryKey: [GET_SPONSORED_PRODUCTS_REPORTS_CAMPAIGN_QUERY_KEY, params],
    queryFn: () => getSponsoredProductsReportsCampaign(params),
    select: data => data.data,
  });
}
